/**
 * BulkResyncIdleState — shown before the first run.
 */
import React from 'react';
import { Server } from 'lucide-react';
import { useT } from '../../i18n/I18nContext.jsx';

export function BulkResyncIdleState() {
  const t = useT();
  return (
    <div style={{
      padding: 24, textAlign: 'center', fontSize: 12,
      color: 'var(--text-muted)', background: 'var(--surface-2)', borderRadius: 8,
      border: '1px dashed var(--border)'
    }}>
      <Server size={28} color="var(--text-muted)" style={{ marginBottom: 10 }} />
      <div>
        {t('erp.bulkResync.idleHint',
          'Click Re-sync All Clients to push the current Tier Privileges configuration to the production ERP DB and pre-compute every licensed client\'s payload.'
        )}
      </div>
    </div>
  );
}
